import { render } from "./UserRegisterView.vue?vue&type=template&id=3054bffd&ts=true"
import script from "./UserRegisterView.vue?vue&type=script&lang=ts"
export * from "./UserRegisterView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__